import axios from "axios";
import { host } from "./config";
import { Message, Loading } from "element-ui";
import router from "@/router/index.js";
import store from "@/store/index";
import { clearToken } from "@/utils/auth";

const service = axios.create({
  baseURL: host,
  timeout: 5000,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/application/json",
  },
});

let loadingInstance = null;

service.interceptors.request.use(
  config => {
    loadingInstance = Loading.service({ fullscreen: true });
    return config;
  },
  error => {
    console.log(error); // for debug
    loadingInstance.close();
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    loadingInstance.close();
    const res = response.data;
    return res;
  },
  error => {
    loadingInstance.close();
    const { data, status } = error.response;
    if (status === 401) {
      const { redirect, platform, role } = store.state.user;
      clearToken();
      store.commit("user/CLEAR_DATA");
      router.replace({
        name: "Login",
        query: {
          redirect,
          platform,
          role,
        },
      });
    }

    const { msg } = data;

    if (error.response)
      if (msg) {
        Message({
          message: msg,
          type: "error",
        });
      }

    return Promise.reject(error);
  }
);

export default service;
